/*
 * File Created: Sunday, 7th May 2023 4:29:01 pm
 * Author: Chenzier Kabrabam
 * Copyright (c) - 2018-2023 Addble Solutions Private Limited. All Rights Reserved.
 */

import AppBar from "@mui/material/AppBar";
import IconButton from "@mui/material/IconButton";
import Box from "@mui/material/Box";
import { MdOutlineShoppingCart } from "react-icons/md";
import { Theme, Typography, useScrollTrigger, useTheme } from "@mui/material";
import { useLocation, useNavigate } from "react-router-dom";
import { Link } from "react-router-dom";
import React from "react";
import { staticData } from "../../data/staticData";
import { Colors } from "../../constants/color";
import { CartContext } from "../../context/cartContext.context";
import type { Appbar as AppbarProps } from "../../types/appbar/appbar.type";

function Appbar({sx, ...rest}: AppbarProps): JSX.Element {
  const theme: Theme = useTheme();
  const location = useLocation();
  const navigate = useNavigate();
  const { items } = React.useContext(CartContext);

  console.log("APPBAR : USEPARAMS : ", location.pathname);

  const threshold = useScrollTrigger({
    disableHysteresis: true,
    threshold: 400,
  });

  const handleCartOnClick = () => {
    navigate("/order", { preventScrollReset: true });
  };

  return (
    <AppBar
      component="header"
      sx={{
        height: {xs: "54px", md: "64px"},
        boxShadow: "none",
        backgroundColor: {
          xs:
            threshold || location.pathname !== "/" 
              ? Colors.cyan_blue
              : "transparent",
        },
        // transition: "all 1000ms cubic-bezier(0.55, 0.09, 0.68, 0.53)",
        animationName: threshold ? "slide-down" : "none",
        animationDuration: "400ms",
        animationTimingFunction: "cubic-bezier(0.46, 0.03, 0.52, 0.96)",
        animationFillMode: "both",
        "@keyframes slide-down": {
          from: {
            opacity: 0,
            transform: "translateY(-54px)",
          },
          to: {
            opacity: 1,
            transform: "translateY(0)",
          },
        },
        ...sx
      }}
      color="transparent"
      {...rest}
    >
      <Box
        sx={{
          width: "100%",
          height: "inherit",
          display: "flex",
          flexDirection: "row",
          alignItems: "center",
          justifyContent: "space-between",
          padding: {
            xs: theme.spacing(1.5, 1),
            md: theme.spacing(1.5, 2),
            lg: theme.spacing(1.5, 8),
            xl: theme.spacing(1.5, 10),
          },
        }}
      >
        <Box
          sx={{
            color: Colors.white,
          }}
        >
          {staticData.siteProfile.logo[0].src.length !== 0 ? (<Link to="/">
            <Box
              component="img"
              src={staticData.siteProfile.logo[0].src}
              alt={staticData.siteProfile.logo[0].name}
              sx={{
                width: theme.typography.pxToRem(105),
                // height: theme.typography.pxToRem(24),
              }}
            />
          </Link>) : <Typography variant="h5" sx={{ fontSize: { xs: "20px", }}}>{staticData.siteProfile.name}</Typography>}
        </Box>
        <Box>
          <Box
            sx={{
              display: location.pathname === "/order" ? "none" : "flex",
              flexDirection: "row",
              alignItems: "center",
              justifyContent: "center",
              // backgroundColor: "green",
            }}
          >
            <IconButton onClick={handleCartOnClick} disableTouchRipple>
              <MdOutlineShoppingCart style={{ color: Colors.white }} />
            </IconButton>
            <Box
              sx={{
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                width: "20px",
                height: "20px",
                backgroundColor: Colors.fallow,
                color: Colors.white,
                borderRadius: "50%",
              }}
            >
              {items !== undefined ? items.length : 0}
            </Box>
          </Box>
        </Box>
      </Box>
    </AppBar>
  );
}

export default React.memo(Appbar);
